// import pixAxiosSyncRequests from '@/axios/pixAxiosSyncRequests.js';
import pixAxios from '@/axios/pixAxios.js';

export default {
  searchCertificationSection: async (params) => {
    const response = await pixAxios.post('api/Certification/SearchCertificationSection', params);
    return response.data;
  },

  addCertificationSection: async (params) => {
    return pixAxios.post('api/Certification/AddCertificationSection', params);
  },

  updateCertificationSection: async (params) => {
    return pixAxios.post('api/Certification/UpdateCertificationSection', params);
  },

  deleteCertificationSection: async (params) => {
    return pixAxios.post('api/Certification/DeleteCertificationSection', params);
  },
};
